import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { ReportProductionOperatorPDF } from "./Components/PDF/ReportProductionOperatorPDF";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";

import { DrawerFilterProductionOperator } from "./Components/Form/DrawerFilter/DrawerFilterProductionOperator";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { NoEmptyPdfCore } from "src/Pages/components/PDF/NoEmpty/NoEmptyPdfCore";

export const PageReportProductionOperator = () => {
  const { loadingGravar } = useConfigPageContext();
  const { listReportProductionOperator } = useContextReportsProduction();

  const hasData = !!listReportProductionOperator?.data?.length;

  return (
    <>
      <CardHeaderCore
        buttonAdd={[<DrawerFilterProductionOperator key="filter" />]}
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Gere relatórios detalhados de produção por operadora com filtros personalizados"
        title="Relatório de produção por operadora"
      />

      <ReportProductionOperatorPDF />

      {!hasData && !loadingGravar && (
        <NoEmptyPdfCore />
      )}
    </>
  );
};
